/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Affiliates_EyebrowInputs */

const en_directory_resources_affiliates_eyebrow = /** @type {(inputs: Directory_Resources_Affiliates_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate program`)
};

const zh_directory_resources_affiliates_eyebrow = /** @type {(inputs: Directory_Resources_Affiliates_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐计划`)
};

/**
* | output |
* | --- |
* | "Affiliate program" |
*
* @param {Directory_Resources_Affiliates_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_affiliates_eyebrow = /** @type {((inputs?: Directory_Resources_Affiliates_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Affiliates_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_affiliates_eyebrow(inputs)
	return zh_directory_resources_affiliates_eyebrow(inputs)
});
export { directory_resources_affiliates_eyebrow as "directory.resources.affiliates.eyebrow" }